import React from 'react';
import './BannerHomePage.scss';

function PaginationCircle(props) {
  const { i, setActiveIndex, activeIndex, item, setIsActiveIntervalAutoOpenBanner, gtag4, switchExtraction } = props;
  const colorActive = `pagination-circle ${activeIndex === i ? 'circle-active' : ''}`; //Pressing a circle button changes color

  const clickCircle = (i) => {
    setActiveIndex(i);
    setIsActiveIntervalAutoOpenBanner(false);
    gtag4({ // Google analytic 4
      event: 'HomepageCarousel_BannerImp',
      category: item?.titleBannerClose,
      section: 'HomepageCarousel',
      title: switchExtraction(item?.priTitleMobile),
      content: switchExtraction(item?.textBannerMobile),
      place: i,
    });
  };

  return (
    <div className={colorActive} onClick={() => clickCircle(i)}></div>
  )
};

export default PaginationCircle;
